export default Object.freeze({
  fields: {},
  fieldResults: {},
  builderFields: [],
});
